import o from 'react';

const CampaignContext = o.createContext({ tenant: "", locale: "", callouts: {}, skin: "", isLoading: false });

export { CampaignContext };
//# sourceMappingURL=src-context-CampaignContext.js.map
